export const en = {
    'edit-smart-centers': 'Change smart centers',
    'no-formats-message': "Smart centers can't be edited for this ad. Try another image.",
    'no-image-message': "Smart centers can't be edited for ads without images"
};
